import { useNavigate } from 'react-router-dom';
import * as React from 'react';
import { useEffect, useState } from 'react';
// react
import { Helmet } from 'react-helmet-async';
// @mui
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { Typography, Stack, Box } from '@mui/material';
import WidgetsIcon from '@mui/icons-material/Widgets';

import config from '../config.json';
import { cores, VAR_PRIMARIA_RGB } from '../styles/styleUtils';

const StyledContent = styled('div')(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  padding: theme.spacing(10, 4),
  backgroundColor: '#f6f7f9',
}));

const modulos = config.modulos


// ----------------------------------------------------------------------

export default function Modulos() {
  const navigate = useNavigate();

  const [modulosLiberados, setModulosLiberados] = useState([])
  const usuarioLogado = JSON.parse(localStorage.getItem('userData'))

  useEffect(() => {
    if (usuarioLogado?.modulos) {
      // Filtra os módulos ativos
      const modulosAtivos = usuarioLogado.modulos
        .filter(modulo => modulo.ativo)
        .map(moduloAtivo => {
          // Encontra o módulo correspondente no array de modulos
          return modulos.find(modulo => modulo.id === moduloAtivo.id);
        })
        .filter(Boolean); // Remove valores 'undefined' caso algum ID não corresponda

      setModulosLiberados(modulosAtivos);
    }
  }, []);

  const handleClick = (value) => {
    if(usuarioLogado.supervisor){
      navigate(value.target, { replace: true });
      return;
    }
    navigate(value.target2, { replace: true });
  };

  const primeiroNome = usuarioLogado?.nome ? usuarioLogado.nome.split(' ')[0] : null;

  return (
    <>
      <Helmet>
        <title> Módulos </title>
      </Helmet>

      <StyledContent>
        <Box sx={{ maxWidth: 1080, width: '100%' }}>
          <Stack gap={0.5} sx={{ mb: 6 }}>
            <Stack direction="row" alignItems="center" gap={1}>
              <WidgetsIcon fontSize="small" sx={{ color: cores.laranja }} />
              <Typography
                variant="overline"
                sx={{ color: cores.laranja, letterSpacing: 1.2, fontWeight: 700, lineHeight: 1.6 }}
              >
                {primeiroNome ? `Olá, ${primeiroNome}` : 'Bem-vindo'}
              </Typography>
            </Stack>
            <Typography variant="h4" sx={{ fontWeight: 700, color: '#1a1a2e' }}>
              Selecione um módulo
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(26,26,46,0.55)' }}>
              Escolha a área do sistema que deseja acessar
            </Typography>
          </Stack>

          <Grid container spacing={3}>
            {modulosLiberados.length > 0 ? modulosLiberados.map((value, index) => (
              <Grid key={index} item xs={12} sm={6} md={4} lg={3}>
                <Paper
                  onClick={() => { handleClick(value) }}
                  elevation={0}
                  sx={{
                    height: '100%',
                    borderRadius: 3,
                    cursor: 'pointer',
                    textAlign: 'center',
                    overflow: 'hidden',
                    border: '1px solid rgba(16,24,40,0.08)',
                    boxShadow: '0 1px 3px rgba(16,24,40,0.06)',
                    transition: 'transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 16px 28px rgba(16,24,40,0.14)',
                      borderColor: `rgba(var(${VAR_PRIMARIA_RGB}), 0.45)`,
                    },
                  }}
                >
                  <Box sx={{ height: 4, backgroundColor: value.color || cores.laranja }} />
                  <Box sx={{ px: 3, py: 4 }}>
                    <Box
                      sx={{
                        width: 84,
                        height: 84,
                        borderRadius: '50%',
                        mx: 'auto',
                        mb: 2.5,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#f1f2f5',
                      }}
                    >
                      <img src={value.icon} alt={value.nome} style={{ height: 48, width: 48 }} />
                    </Box>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1a1a2e' }}>
                      {value.nome}
                    </Typography>
                  </Box>
                </Paper>
              </Grid>
            )) : (
              <Grid item xs={12} sx={{ textAlign: 'center', py: 8 }}>
                <Typography variant="body2" sx={{ color: 'rgba(26,26,46,0.5)' }}>
                  Nenhum módulo liberado para o seu usuário. Fale com um supervisor para solicitar acesso.
                </Typography>
              </Grid>
            )}
          </Grid>
        </Box>
      </StyledContent>
    </>
  );
}